export const REMOVE_ACTIVE_LAND_PACKAGE = 'REMOVE_ACTIVE_LAND_PACKAGE'

export const removeActiveLandPackages = (packageKey, landProgramKey) => ({
  type: REMOVE_ACTIVE_LAND_PACKAGE,
  payload: {
    packageKey,
    landProgramKey
  }
})
